export class ApiError extends Error {
  public statusCode: number;
  public code?: string;

  constructor(message: string, statusCode: number, code?: string) {
    super(message);
    this.name = 'ApiError';
    this.statusCode = statusCode;
    this.code = code;
  }
}

type ErrorInfo =
  | { errorType: 'apiError'; statusCode: number }
  | { errorType: 'unknown' };

export function getErrorInfo(error: unknown): ErrorInfo {
  if (error instanceof ApiError) {
    return { errorType: 'apiError', statusCode: error.statusCode };
  }
  if (
    error &&
    typeof error === 'object' &&
    'status' in error &&
    typeof error.status === 'number'
  ) {
    return {
      errorType: 'apiError',
      statusCode: error.status,
    };
  }
  return { errorType: 'unknown' };
}
